import store from '../store'
import { includes } from 'lodash'
import auth from '../domain/auth/services/auth'

const isAuthRoute = route => route.path.indexOf('/auth') !== -1
const isLogged = () => store.getters.isLogged
const publicRoutes = ['/recuperar'] // insert public routes here

export default (to, from, next) => {
  if (!isAuthRoute(to) && !isLogged() && !includes(publicRoutes, to)) {
    if (auth.loggedIn()) { // O usuário está logado (localStorage cache) mas as informações não estão no store
      store.dispatch('attemptLogin', {
        email: ':)',
        password: 'hacker'
      })
        .then(() => {
          if (JSON.parse(localStorage.getItem('somenteConsultaReboque'))) {
            next({name: 'config.consulta-reboque'})
          } else {
            next()
          }
        })
    } else {
      const destino = to.fullPath === '/definir-senha' ? '/dashboard' : to.fullPath
      next({
        path: '/auth',
        query: { redirect: destino }
      })
    }
  } else if (isLogged() && precisaDefinirSenha(to)) {
    next({ name: 'definir.senha.primeiro.acesso' })
  } else {
    next()
  }
}

function precisaDefinirSenha (route) {
  const isPrimeiroAcesso = JSON.parse(localStorage.getItem('primeiroAcesso'))
  const routesExcecoes = ['/definir-senha', '/logout', ...publicRoutes]

  return !isAuthRoute(route) && isPrimeiroAcesso && !includes(routesExcecoes, route.path)
}



// WEBPACK FOOTER //
// ./src/router/beforeEach.js